<template functional>
  <div style="align-content: center">
    <table class="table table-striped table-bordered not-last-td table-data">
      <thead>
        <tr class="cusmtom-thead-color">
          <th scope="col" class="text-center p-3 custom-header-label">
             <translate-text keyTranslate="common_words.code"/>
          </th>
          <th scope="col" class="text-center p-3 custom-header-label">
             <translate-text keyTranslate="inventory.articles"/>
          </th>
          <th scope="col" class="text-center p-3 custom-header-label">
             <translate-text keyTranslate="common_words.quantity"/>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(article, index) in props.row.articles" :key="index">
          <td class="text-center">
            {{ article.code ? article.code : 'N/A' }}
          </td>
          <td class="text-center">
            {{ article.name }}
          </td>
          <td class="text-center">
            {{ article.pivot.quantity }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'ArticleInfo',
};
</script>
